export const SessionDetailsTestIds = {
  ipHeader: 'ip_header',
  ipData: 'ip_data',
  lastSeenHeader: 'last_seen_header',
  lastSeenData: 'last_seen_data',
  userAgentHeader: 'user_agent_header',
  userAgentData: 'user_agent_data'
} as const;
